import { Account } from '@adtrackify/at-tracking-event-types';

import { AccountListItem } from './account-list-item';

import { CommandEmpty, CommandGroup, CommandList } from '@/components/ui/command';
import { VirtualCommandList } from '@/features/workspace/components/team-switcher/command-virtual';

interface AccountListProps {
  accounts: Account[];
  currentAccountId?: string;
  isLoading: boolean;
  useVirtual: boolean;
  itemHeight: number;
  onSelect: (accountId: string) => void;
}

const accountListClassName =
  'max-h-none min-h-0 min-w-0 flex-1 overflow-x-hidden overflow-y-auto';

export function AccountList({
  accounts,
  currentAccountId,
  isLoading,
  useVirtual,
  itemHeight,
  onSelect,
}: AccountListProps) {
  if (useVirtual) {
    if (accounts.length === 0) {
      return (
        <CommandList className={accountListClassName}>
          <CommandEmpty>No store found.</CommandEmpty>
        </CommandList>
      );
    }

    return (
      <VirtualCommandList
        className={accountListClassName}
        itemHeight={itemHeight}
        overscan={10}
      >
        {accounts.map(account => (
          <AccountListItem
            key={account.id}
            account={account}
            isSelected={currentAccountId === account.id}
            isLoading={isLoading}
            onSelect={onSelect}
          />
        ))}
      </VirtualCommandList>
    );
  }

  return (
    <CommandList className={accountListClassName}>
      <CommandEmpty>No store found.</CommandEmpty>
      <CommandGroup className="min-w-0 overflow-hidden">
        {accounts.map(account => (
          <AccountListItem
            key={account.id}
            account={account}
            isSelected={currentAccountId === account.id}
            isLoading={isLoading}
            onSelect={onSelect}
          />
        ))}
      </CommandGroup>
    </CommandList>
  );
}
